// extracted by mini-css-extract-plugin
export default {"creditPointsText":"HomeSectionsCard_creditPointsText__YccEJ","creditPointsTitle":"HomeSectionsCard_creditPointsTitle__FF3dn"};